<script>
  import { spring } from 'svelte/motion';

	let coords = spring({ x: 50, y: 50 }, {
		stiffness: 0.2,
		damping: 0.2
	});

	let size = spring(20);
</script>

<style>
  svg {
    width: 100%;
    height: 100%;
    margin: -8px;
  }

  circle {
    fill: white;
  }

  .mosebox {
    position: fixed;
    width: 100%;
    height: 99vh;
    z-index: 9;
    mix-blend-mode: exclusion;
  }
</style>

<div class="mosebox">
	<svg
	on:mousemove="{e => coords.set({ x: e.clientX, y: e.clientY })}"
	on:mousedown="{() => size.set(100)}"
	on:mouseup="{() => size.set(20)}"
	>
		<circle cx={$coords.x} cy={$coords.y} r={$size}/>
	</svg>
</div>
